import React from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

type DashboardCardWrapperProps = {
  variant?: "default" | "highlight" | "warning" | "favourite";
  children: React.ReactNode;
  className?: string;
  shouldBlink?: boolean;
};

const DashboardCardWrapper: React.FC<DashboardCardWrapperProps> = ({
  variant = "default",
  children,
  className,
  shouldBlink = false,
}) => {
  const variantClasses = {
    default: "border border-gray-200 bg-white dark:bg-gray-900",
    highlight: "border-blue-200 bg-blue-50 dark:bg-blue-900/40",
    warning: "border-yellow-200 bg-yellow-50 dark:bg-yellow-900/20",
    favourite: "border-[#FFA500] dark:border-[#FFA500] bg-white dark:bg-gray-900 shadow-[0_4px_16px_4px_rgba(88,200,255,1)]",
  };

  const hoverShadow =
    variant === "favourite"
      ? "hover:shadow-[0_4px_20px_4px_rgba(88,200,255,1)]"
      : "hover:shadow-[0_4px_20px_rgba(0,0,0,0.15)]";

  return (
    <Card
      className={cn(
        "rounded-lg border transition-shadow duration-200 border dark:border-gray-700",
        hoverShadow,
        variantClasses[variant],
        shouldBlink && "blink-shadow border-[#FFA500] dark:border-[#FFA500]",
        className
      )}
    >
      {children}
    </Card>
  );
};

export default DashboardCardWrapper;